/* ============================================================
   BB Dental Supply — theme.js
   Mega menu · mobile nav · Ajax cart drawer · quick view · qty
   ============================================================ */
(function () {
  'use strict';
  const money = (cents) => {
    try {
      return (window.BB && window.BB.moneyFormat
        ? window.BB.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
        : '$' + (cents / 100).toFixed(2));
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------------- mega menu ---------------- */
  function initMega() {
    const btn = $('[data-mega-toggle]');
    const panel = $('[data-mega]');
    const scrim = $('[data-mega-scrim]');
    if (!btn || !panel) return;
    const close = () => { panel.hidden = true; if (scrim) scrim.hidden = true; };
    const open = () => { panel.hidden = false; if (scrim) scrim.hidden = false; };
    btn.addEventListener('click', (e) => { e.stopPropagation(); panel.hidden ? open() : close(); });
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  /* ---------------- mobile nav ---------------- */
  function initMobileNav() {
    const root = $('[data-mobile-nav]');
    const openBtns = $$('[data-mobile-open]');
    const closeEls = $$('[data-mobile-close]');
    if (!root) return;
    openBtns.forEach((b) => b.addEventListener('click', () => root.classList.add('open')));
    closeEls.forEach((b) => b.addEventListener('click', () => root.classList.remove('open')));
  }

  /* ---------------- cart drawer ---------------- */
  const Cart = {
    root: null,
    open() { if (this.root) { this.root.classList.add('open'); document.body.style.overflow = 'hidden'; } },
    close() { if (this.root) { this.root.classList.remove('open'); document.body.style.overflow = ''; } },
    async refresh() {
      try {
        const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
        const cart = await res.json();
        this.render(cart);
      } catch (e) { /* not on Shopify (preview) — ignore */ }
    },
    render(cart) {
      const count = cart.item_count;
      $$('[data-cart-count]').forEach((el) => { el.textContent = count; });
      const body = $('[data-drawer-body]');
      const foot = $('[data-drawer-foot]');
      const empty = $('[data-drawer-empty]');
      if (!body) return;
      if (count === 0) {
        body.hidden = true; if (foot) foot.hidden = true; if (empty) empty.hidden = false;
        return;
      }
      if (empty) empty.hidden = true;
      body.hidden = false; if (foot) foot.hidden = false;
      body.innerHTML = cart.items.map((it, i) => `
        <div class="line">
          <div class="thumb">${it.image ? `<img src="${it.image}" alt="">` : '<div class="ph" style="width:100%;height:100%"></div>'}</div>
          <div style="flex:1;min-width:0">
            <div class="n">${it.product_title}</div>
            <div class="mono" style="font-size:10.5px;color:#8aa3b3;margin-top:3px">${it.sku || ''}</div>
            <div style="display:flex;align-items:center;justify-content:space-between;margin-top:9px;gap:8px">
              <div class="qty">
                <button data-change="${i + 1}" data-to="${it.quantity - 1}">−</button>
                <span class="v">${it.quantity}</span>
                <button data-change="${i + 1}" data-to="${it.quantity + 1}">+</button>
              </div>
              <div class="price" style="font-size:15px">${money(it.line_price)}</div>
            </div>
          </div>
          <button data-change="${i + 1}" data-to="0" style="align-self:flex-start;color:#b5c4cf">✕</button>
        </div>`).join('');
      const sub = $('[data-cart-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
      const tot = $('[data-cart-total]'); if (tot) tot.textContent = money(cart.total_price);
      const ship = $('[data-cart-ship]');
      if (ship) ship.textContent = cart.total_price >= 25000 ? 'FREE' : money(1200);
      body.querySelectorAll('[data-change]').forEach((b) => {
        b.addEventListener('click', () => this.change(b.dataset.change, parseInt(b.dataset.to, 10)));
      });
    },
    async change(line, qty) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
        });
        this.render(await res.json());
      } catch (e) {}
    },
    async add(id, qty = 1) {
      try {
        await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty }] })
        });
        await this.refresh();
        this.open();
      } catch (e) { this.open(); }
    }
  };

  function initCart() {
    Cart.root = $('[data-cart-drawer]');
    $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); Cart.open(); }));
    $$('[data-cart-close]').forEach((b) => b.addEventListener('click', () => Cart.close()));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') Cart.close(); });
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      const id = btn.getAttribute('data-variant-id');
      const qtyInput = btn.closest('form, [data-pdp]') ? (btn.closest('form, [data-pdp]').querySelector('[data-qty-val]')) : null;
      const qty = qtyInput ? parseInt(qtyInput.textContent || qtyInput.value || '1', 10) : 1;
      if (id) Cart.add(id, qty); else Cart.open();
    });
    Cart.refresh();
  }

  /* ---------------- quick view ---------------- */
  function initQuick() {
    const modal = $('[data-quick]');
    if (!modal) return;
    const fill = (data) => {
      const set = (sel, val, attr) => { const el = modal.querySelector(sel); if (el) { attr ? el.setAttribute(attr, val) : (el.textContent = val); } };
      set('[data-q-title]', data.title);
      set('[data-q-sku]', data.sku);
      set('[data-q-cat]', data.cat);
      set('[data-q-price]', data.price);
      set('[data-q-reviews]', data.reviews + ' reviews');
      set('[data-q-desc]', data.desc);
      const img = modal.querySelector('[data-q-img]');
      const ph = modal.querySelector('[data-q-ph]');
      if (data.image && img) { img.src = data.image; img.hidden = false; if (ph) ph.hidden = true; }
      else { if (img) img.hidden = true; if (ph) ph.hidden = false; }
      const addBtn = modal.querySelector('[data-add-to-cart]');
      if (addBtn && data.vid) addBtn.setAttribute('data-variant-id', data.vid);
    };
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-quick-open]');
      if (!btn) return;
      e.preventDefault();
      fill({
        title: btn.dataset.title, sku: btn.dataset.sku, cat: btn.dataset.cat,
        price: btn.dataset.price, reviews: btn.dataset.reviews || '0', desc: btn.dataset.desc || '',
        image: btn.dataset.image || '', vid: btn.dataset.vid || ''
      });
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    modal.querySelectorAll('[data-quick-close]').forEach((b) => b.addEventListener('click', () => {
      modal.classList.remove('open'); document.body.style.overflow = '';
    }));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { modal.classList.remove('open'); document.body.style.overflow = ''; } });
  }

  /* ---------------- qty steppers ---------------- */
  function initQty() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      const wrap = btn.closest('[data-qty]');
      if (!wrap) return;
      const val = wrap.querySelector('[data-qty-val]');
      let n = parseInt(val.textContent || val.value || '1', 10) + parseInt(btn.dataset.qtyStep, 10);
      if (n < 1) n = 1;
      if (val.value !== undefined && val.tagName === 'INPUT') val.value = n; else val.textContent = n;
    });
  }

  /* ---------------- pdp gallery ---------------- */
  function initGallery() {
    $$('[data-gallery]').forEach((g) => {
      const main = g.querySelector('[data-gallery-main]');
      g.querySelectorAll('[data-gallery-thumb]').forEach((t) => {
        t.addEventListener('click', () => {
          const src = t.querySelector('img');
          if (src && main && main.querySelector('img')) main.querySelector('img').src = src.src;
        });
      });
    });
  }

  function init() {
    initMega(); initMobileNav(); initCart(); initQuick(); initQty(); initGallery();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
